import React from 'react';
import { TouchableOpacity } from 'react-native';
import { Text } from 'react-native';

const DataCell = ({ column, row }) => {
  const displayValue = row[column?.field];
  const isSortable = column?.sortable === true;
  return (
    <TouchableOpacity
      style={{
        height: '100%',
        flex: 1,
        justifyContent: 'center',
        alignItems: isSortable ? 'flex-end' : 'flex-start',
        paddingHorizontal: 8
      }}>
      <Text variant='body2' fontWeightType='medium'>
        {displayValue ?? '--'}
      </Text>
    </TouchableOpacity>
  );
};

export default DataCell;